import "@/App.css";
import Hero from "@/components/sections/Hero";
import BookingCalendar from "@/components/sections/BookingCalendar";
import SavingsNumbers from "@/components/sections/SavingsNumbers";
import Financing from "@/components/sections/Financing";
import OfferStack from "@/components/sections/OfferStack";
import Equipment from "@/components/sections/Equipment";
import FeaturedReview from "@/components/sections/FeaturedReview";
import Testimonials from "@/components/sections/Testimonials";
import Gallery from "@/components/sections/Gallery";
import FAQ from "@/components/sections/FAQ";
import AboutUs from "@/components/sections/AboutUs";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <div className="App">
      <Hero />
      <BookingCalendar />
      <SavingsNumbers />
      <Financing />
      <OfferStack />
      <Equipment />
      <FeaturedReview />
      <Testimonials />
      <Gallery />
      <FAQ />
      <AboutUs />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
